import z from "zod";
export const VisionInstanceIdSchema = z
    .uuid()
    .brand();
export const VisionInstanceSchema = z
    .object({
    id: VisionInstanceIdSchema,
    name: z.string().min(1).max(255),
    inboundApiKey: z.string().min(1).max(255),
    outboundApiKey: z.string().min(1).max(255),
    apiUrl: z.string().min(1).max(255),
    shareCodePrefix: z.string().length(1),
})
    .brand();
//# sourceMappingURL=visionInstance.js.map